import styled, { css } from 'styled-components';

const cardTitleBase = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  word-break: break-word;
`;

const cardTextBase = css`
  font-size: 14px;
  line-height: 1.4;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const CardBubble = styled.div`
  width: 100%;
  max-width: 320px;
  border-radius: 18px;
  overflow: hidden;
  background: ${({ theme }) => theme.vars.newColor.white};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
`;

export const CardMediaWrapper = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  min-height: 120px;
  background: ${({ theme }) => theme.vars.newColor.lightGS2};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const CardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardMediaPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  font-size: 13px;
  padding: 16px;
  text-align: center;
`;

export const CardContent = styled.div`
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CardTitle = styled.div`
  ${cardTitleBase}
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

export const CardTitlePlaceholder = styled.div`
  ${cardTitleBase}
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  font-style: italic;
`;

export const CardText = styled.div`
  ${cardTextBase}
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

export const CardTextPlaceholder = styled.div`
  ${cardTextBase}
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  font-style: italic;
`;

export const CardButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

const cardButtonVisual = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 20px;
  background: ${({ theme }) => theme.vars.newColor.blue1};
  color: ${({ theme }) => theme.vars.newColor.white};
  font-size: 13px;
  font-weight: 500;
  max-width: 100%;
  min-height: 36px;
  box-sizing: border-box;
`;

export const CardButton = styled.div`
  ${cardButtonVisual}
`;

export const CardButtonLink = styled.a`
  ${cardButtonVisual}
  text-decoration: none;
  cursor: pointer;
  &:hover {
    opacity: 0.92;
  }
`;

export const CardButtonIcon = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  font-size: 12px;
`;
